
import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../../store/api/rx-factory'
import * as Enpoints from '../../../../../store/api/endpoints'
import moment from 'moment'
import EventBus from '../lib/event-bus';

let loaderRun = 0;
function goToUrl(url, action) {
    window.navigator.saysWho = (() => {
        const { userAgent } = navigator;
        let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(match[1])) {
            var temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return `IE ${temp[1] || ""}`;
        }
        match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, "-?"];
        return match[0];
    })();
    // console.log("console firszt============>", url)
    if (navigator.saysWho.toLowerCase() === "safari") {
        location.replace(url);
    } else {
        // window.open(url, action)
        console.log("console firszt", url);
        var newWin = window.open(url, action);

        // alert("first")
        if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
            // alert("hi")
            location.replace(url);
        }
    }
}

export const actions = {
	//cancel withdrawal request
	[Const.RUN_CANCEL_WITHDRAWAL_REQUEST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_CANCEL_WITHDRAWAL_REQUEST, credentials,credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.$router.replace('/support/closeRequest')
			} else {
				COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_LANGUAGE_API]({ commit, state, getters }, credentials) {
		localStorage.setItem('lang', credentials.globalParams.lang)
		if (credentials.localParams.page == 'left-bar') {
			//document.cookie = credentials.globalParams.lang;
			_executeApi(Enpoints.EP_LANGUAGE_API, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
				if (!error) { } else { }
			})
		} else {

		}

	},
	//====================trading-tools===================================================================
	[Const.RUN_GET_ECONOMIC_CALENDER_DATA]({ commit, state, getters, dispatch }, credentials) {

		let auto_chartist = ''
		if (credentials.globalParams.from == '') {
			auto_chartist = getters[Const.GET_ECONOMIC_CALENDER_DATA]
		} else {
			auto_chartist = {}
		}
		_executeApi(Enpoints.EP_GET_ECONOMIC_CALENDER_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (auto_chartist != '' && auto_chartist != undefined) {
					if (result.res_data.length > 0) {
						for (let i = 0; i <= result.res_data.length - 1; i++) {

							const eventDate = moment(result.res_data[i].Date).format("YYYY-MM-DD")

							if (auto_chartist[eventDate]) {
								auto_chartist[eventDate].push(result.res_data[i])
							} else {
								auto_chartist[eventDate] = []
								auto_chartist[eventDate].push(result.res_data[i])
							}
							if (i == result.res_data.length - 1) {
								commit(Const.SET_ECONOMIC_CALENDER_DATA, auto_chartist)
							}
						}
					}
				} else {
					commit(Const.SET_ECONOMIC_CALENDER_DATA, result.res_data)
				}
			} else {
				commit(Const.SET_ECONOMIC_CALENDER_DATA, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_COUPON_PLAN]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_COUPON_PLAN, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (result.res_data != '') {
					let amount = credentials.localParams.parameter.amount - result.res_data[0].discount_amount
					credentials.localParams.parameter.coupon_apply = true
					credentials.localParams.parameter.coupon_code1 = result.res_data[0].code
					credentials.localParams.parameter.coupon_price = result.res_data[0].discount_amount
					if (amount < 0) {
						credentials.localParams.parameter.amount = 0
					} else {
						credentials.localParams.parameter.amount = amount
					}
				} else {
					credentials.localParams.parameter.amount = credentials.localParams.parameter.planDetailData.amount
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_COUPON_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_COUPON_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_COUPON_LIST, result.res_data)
			} else {
				commit(Const.SET_COUPON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_CHECK_COUPON_VALIDITY]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_CHECK_COUPON_VALIDITY, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.applycoupon(result.res_data, 'apply')

			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},

	[Const.RUN_GET_AUTOCHARTIST_DATA]({ commit, state, getters, dispatch }, credentials) {
		let auto_chartist = [];
		let auto_chartistJson = getters[Const.GET_AUTO_CHARTIST]
		_executeApi(Enpoints.EP_GET_AUTOCHARTIST_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (auto_chartist != '' && auto_chartist != undefined) {
					auto_chartist = auto_chartistJson.records
					let signalJson = {};
					if (result.res_data.length > 0) {
						for (let i = 0; i <= result.res_data.length - 1; i++) {
							auto_chartist.push(result.res_data[i])
							if (i == result.res_data.length - 1) {
								signalJson['totalRecords'] = result.res_data.length + auto_chartist.length
								signalJson['records'] = auto_chartist
								commit(Const.SET_AUTO_CHARTIST, signalJson)
							}
						}
					} else {
						signalJson['totalRecords'] = auto_chartist.length
						signalJson['records'] = auto_chartist
						commit(Const.SET_AUTO_CHARTIST, signalJson)
					}
				} else {
					let signalArray = [], signalJson = {};
					if (result.res_data.length > 0) {
						for (let i = 0; i <= result.res_data.length - 1; i++) {
							signalArray.push(result.res_data[i])

							if (i == result.res_data.length - 1) {
								signalJson['totalRecords'] = result.res_data.length
								signalJson['records'] = signalArray
								commit(Const.SET_AUTO_CHARTIST, signalJson)
							}
						}
					} else {
						signalJson['totalRecords'] = 0
						signalJson['records'] = signalArray
						commit(Const.SET_AUTO_CHARTIST, signalJson)
					}
				}
			} else {
				commit(Const.SET_AUTO_CHARTIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_CURRENT_NEWS]({ commit, state, getters, dispatch }, credentials) {
		let auto_array = [];
		let newsJson = getters[Const.GET_CURRENT_NEWS]
		_executeApi(Enpoints.EP_GET_CURRENT_NEWS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				result.res_data = result.res_data.filter(val => val.tags || val.title || val.description)
				if (credentials.localParams.page && credentials.localParams.page == 'news') {
					if (credentials.localParams.parameter.localNewsData.length == 0) {
						credentials.localParams.parameter.localNewsData = result.res_data.slice(0, 10)
					}
				}
				if (parseInt(credentials.localParams.parameter.page) > 1) {
					if (newsJson.totalRecords) {
						newsJson['totalRecords'] = newsJson['totalRecords'] + result.res_data.length
						newsJson['records'] = newsJson['records'].concat(result.res_data)
					} else {
						newsJson['totalRecords'] = result.res_data.length
						newsJson['records'] = result.res_data
					}
					commit(Const.SET_CURRENT_NEWS, newsJson)
				} else {
					let news = {}
					news['totalRecords'] = result.res_data.length
					news['records'] = result.res_data
					commit(Const.SET_CURRENT_NEWS, news)
				}
				// if (auto_array != '' && auto_array != undefined) {
				// 	auto_array = newsJson.records
				// 	let newsJson = {};
				// 	if (result.res_data.length > 0) {
				// 		for (let i = 0; i <= result.res_data.length - 1; i++) {
				// 			auto_array.push(result.res_data[i])

				// 			if (i == result.res_data.length - 1) {
				// 				newsJson['totalRecords'] = result.res_data.length + auto_array.length
				// 				newsJson['records'] = auto_array
				// 				commit(Const.SET_CURRENT_NEWS, newsJson)
				// 			}
				// 		}
				// 	} else {
				// 		newsJson['totalRecords'] = auto_array.length
				// 		newsJson['records'] = auto_array
				// 		commit(Const.SET_CURRENT_NEWS, newsJson)
				// 	}
				// } else {
				// 	let newsArray = [], newsJson = {};
				// 	if (result.res_data.length > 0) {
				// 		for (let i = 0; i <= result.res_data.length - 1; i++) {
				// 			newsArray.push(result.res_data[i])

				// 			if (i == result.res_data.length - 1) {
				// 				newsJson['totalRecords'] = result.res_data.length
				// 				newsJson['records'] = newsArray
				// 				commit(Const.SET_CURRENT_NEWS, newsJson)
				// 			}
				// 		}
				// 	} else {
				// 		newsJson['totalRecords'] = 0
				// 		newsJson['records'] = newsArray
				// 		commit(Const.SET_CURRENT_NEWS, newsJson)
				// 	}
				// }
			} else {
				commit(Const.SET_CURRENT_NEWS, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_CURRENT_NEWS_DETAIL]({ commit, state, getters, dispatch }, credentials) {
		let newsJson = getters[Const.GET_CURRENT_NEWS_DETAIL]
		_executeApi(Enpoints.EP_GET_CURRENT_NEWS_DETAIL, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				newsJson[credentials.globalParams.id] = result.res_data
				commit(Const.SET_CURRENT_NEWS_DETAIL, newsJson)
				credentials.localParams.parameter.id = ''
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_SIGNAL_CENTRE_DATA]({ commit, state, getters, dispatch }, credentials) {
		let auto_chartist = [];
		let auto_chartistJson = getters[Const.GET_SIGNAL_CENTRE]
		_executeApi(Enpoints.EP_GET_SIGNAL_CENTRE_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (auto_chartist != '' && auto_chartist != undefined) {
					let signalJson = {};
					if (result.res_data.length > 0) {
						for (let i = 0; i <= result.res_data.length - 1; i++) {
							auto_chartist.push(result.res_data[i])

							if (i == result.res_data.length - 1) {
								signalJson['totalRecords'] = result.res_data.length + auto_chartist.length
								signalJson['records'] = auto_chartist
								commit(Const.SET_SIGNAL_CENTRE, signalJson)
							}
						}
					} else {
						signalJson['totalRecords'] = auto_chartist.length
						signalJson['records'] = auto_chartist
						commit(Const.SET_SIGNAL_CENTRE, signalJson)
					}
				} else {
					let signalArray = [], signalJson = {};
					if (result.res_data.length > 0) {
						for (let i = 0; i <= result.res_data.length - 1; i++) {
							signalArray.push(result.res_data[i])

							if (i == result.res_data.length - 1) {
								signalJson['totalRecords'] = result.res_data.length
								signalJson['records'] = signalArray
								commit(Const.SET_SIGNAL_CENTRE, signalJson)
							}
						}
					} else {
						signalJson['totalRecords'] = 0
						signalJson['records'] = signalArray
						commit(Const.SET_SIGNAL_CENTRE, signalJson)
					}
				}
			} else {
				commit(Const.SET_SIGNAL_CENTRE, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},


	[Const.RUN_GET_SUB_PLAN_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_SUB_PLAN_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_SUB_PLAN_LIST, result.res_data)
			} else {
				commit(Const.SET_SUB_PLAN_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_SUB_PLAN_DETAIL]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_SUB_PLAN_DETAIL, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_SUB_PLAN_DETAIL, result.res_data)
				if (credentials.localParams.page == 'create_plan_ticket') {
					for (let i = 0; i <= result.res_data[0].details.length - 1; i++) {
						if (result.res_data[0].details[i].id == credentials.localParams.plan_detail_id) {
							credentials.localParams.parameter.planDetailData = result.res_data[0].details[i]
						}
						if (i == result.res_data[0].details.length - 1) {
							credentials.localParams.parameter.userDepositFunc()
						}
					}
				}

			} else {
				commit(Const.SET_SUB_PLAN_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_SUB_OPERATION_LINK]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_SUB_OPERATION_LINK, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz10', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_SUB_OPERATION]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_SUB_OPERATION, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.transaction_id = result.res_data.trans_id
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_CREATE_SUB_TICKET]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_CREATE_SUB_TICKET, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let get_user = getters[types.GET_USER]
				let sdata = result.res_data.data[0]
				let sub_json = { 'pdetail_id': sdata.pdetail_id, 'plan_id': sdata.id, 'plan_name': sdata.plan_name, 'plan_type': sdata.plan_type }
				get_user.profile.subscriptions.push(sub_json)
				commit(types.SET_STATE, get_user)
				var user = localStorage.getItem('user')
				user = atob(user); 
				user = JSON.parse(user)
				user.profile.subscriptions.push(sub_json)
				localStorage.setItem('user', btoa(JSON.stringify(user)))

				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.transaction_id = ''
					credentials.localParams.parameter.congModuleLev = true
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}

			}
		})
	},
	[Const.RUN_UNSUB_SERVICE]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_UNSUB_SERVICE, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz11', 'success')
				let get_user = getters[types.GET_USER]
				let subArray = get_user.profile.subscriptions


				for (let i = 0; i <= subArray.length - 1; i++) {
					if (parseInt(subArray[i].id) == parseInt(credentials.globalParams.subscription_id)) {
						subArray.splice(i, 1);
					}

					if (i == subArray.length - 1) {
						get_user.profile.subscriptions = subArray
						commit(types.SET_STATE, get_user)
						var user = localStorage.getItem('user')
						user = atob(user)
						user = JSON.parse(user)
						user.profile.subscriptions = subArray
						localStorage.setItem('user', btoa(JSON.stringify(user)))
					}
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},

	[Const.RUN_GET_VPS_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_VPS_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_VPS_LIST, result.res_data)
			} else {
				commit(Const.SET_VPS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_VPS_DETAIL]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_VPS_DETAIL, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_VPS_DETAIL, result.res_data)
			} else {
				commit(Const.SET_VPS_DETAIL, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_VPS_RESTART]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_VPS_RESTART, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz12', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_VPS_REBOOT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_VPS_REBOOT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz13', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_VPS_SHUTDOWN]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_VPS_SHUTDOWN, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.detail()
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz14', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_VPS_CHANGE_PASSWORD]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_VPS_CHANGE_PASSWORD, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.detail()
				credentials.localParams.parameter.reset()
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz15', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//=================================user==============================================================
	[Const.RUN_GET_USER_PROFILE]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_USER_PROFILE, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_USER_PROFILE, result.res_data[0])
			}
		})
	},
	[Const.RUN_GET_USER_REGISTERATION_STEP_DATA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_USER_REGISTERATION_STEP_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter
				result.res_data[0].step = parseInt(result.res_data[0].step)
				switch (parseFloat(credentials.localParams.step)) {
					case 1:
						_that.f_name = result.res_data[0].profile.firstname
						_that.m_name = result.res_data[0].profile.middlename
						_that.l_name = result.res_data[0].profile.lastname
 
						_that.address1 = result.res_data[0].profile.address1
						_that.address2 = result.res_data[0].profile.address2
						_that.post_code = result.res_data[0].profile.post_code
						_that.city = result.res_data[0].profile.city

						_that.pass_num = result.res_data[0].profile.P_IDNUMBER
						_that.mifir = result.res_data[0].profile.mifir
						_that.other_id = result.res_data[0].profile.id_type
						_that.gender = result.res_data[0].profile.gender
						_that.mobile_no = result.res_data[0].profile.mobile_no

						_that.pep = parseInt(result.res_data[0].profile.pep)
						_that.us_person = parseInt(result.res_data[0].profile.us_person)

						_that.dob = moment(result.res_data[0].profile.dob).format('YYYY-MM-DD')
						// _that.dob = new Date(_that.dob)
						if (result.res_data[0].profile.nationality != '' && result.res_data[0].profile.nationality != null) {
							_that.res_nationality = result.res_data[0].profile.nationality
						}
						if (result.res_data[0].profile.tax_residency != '' && result.res_data[0].profile.tax_residency != null) {
							_that.tax_res_country = result.res_data[0].profile.tax_residency
						}
						if (result.res_data[0].profile.residence_country != '' && result.res_data[0].profile.residence_country != null) {
							_that.res_country = result.res_data[0].profile.residence_country
						}
						_that.usFatca = (result.res_data[0].profile.tax_residency == null) ? null : (_that.tax_res_country) ? 0 : 1
						// console.log('==================>',_that.usFatca)
						// _that.tax_recredentialssidency = result.res_data[0].profile.tax_residency
						_that.crs_reason = result.res_data[0].profile.CRSREASON
						_that.crs = result.res_data[0].profile.CRSNUMBER
						_that.is_crs = (_that.crs)? 1:(_that.crs_reason)? 0:null

						if(_that.jurisdiction_tax_residence_list[1] == result.res_data[0].profile.CRSREASON) {
							_that.jurisdiction_tax_residence = 1
						} else if (_that.jurisdiction_tax_residence_list[3] == result.res_data[0].profile.CRSREASON){
							_that.jurisdiction_tax_residence = 3
						} else if (result.res_data[0].profile.CRSREASON) {
							_that.jurisdiction_tax_residence = 2
							_that.crs_reason = result.res_data[0].profile.CRSREASON
						}
						_that.datePickerFunc()
						_that.checkIfMifir()
						break;
					case 2:
						_that.emp_status = result.res_data[0].profile.emp_status
						_that.occupation = result.res_data[0].profile.occupation
						_that.yearly_income = result.res_data[0].profile.yearly_income
						_that.ac_opening_reason = result.res_data[0].profile.ac_opening_reason,
						_that.nature_of_transaction = result.res_data[0].profile.nature_of_transaction
						_that.origin_of_funds = result.res_data[0].profile.origin_of_funds
						_that.net_worth = result.res_data[0].profile.net_worth
						_that.position = result.res_data[0].profile.position
						_that.emp_name = result.res_data[0].profile.emp_name
						_that.education = result.res_data[0].profile.education
						_that.net_disposable_income = result.res_data[0].profile.net_disposable_income
						_that.invested_trading_amount = result.res_data[0].profile.invested_trading_amount
						_that.trading_turnover = result.res_data[0].profile.account_turnover
						_that.source_of_fund = parseInt(result.res_data[0].profile.source_of_fund ) || ''
						if(_that.source_of_fund === 8) {
							if(getters[Const.GET_EMPLOYMENT][result.res_data[0].profile.source_of_fund_other]){
								_that.employment = result.res_data[0].profile.source_of_fund_other
							}else if(result.res_data[0].profile.source_of_fund_other){
								_that.other_employed = result.res_data[0].profile.source_of_fund_other
								_that.employment = 29
							}
						}else if(result.res_data[0].profile.source_of_fund_other && _that.source_of_fund === 8){
							_that.other_employed = result.res_data[0].profile.source_of_fund_other
						}
						break;
					case 3:
						let i, ques_ans_list1 = []
						_that.is_trading_experience = result.res_data[0].profile.is_trading_experience === 1?1:result.res_data[0].profile.is_trading_experience === 2?2:''
						_that.ques_ans_array = _that.ques_ans_array || {};  // Initialize as empty object if undefined
						_that.answer_Selected = _that.answer_Selected || {};
						for (i = 0; i <= result.res_data[0].answers.length - 1; i++) {
							let json = {}
							json['question_id'] = result.res_data[0].answers[i].ques_id
							json['ans_id'] = result.res_data[0].answers[i].ans_id
							json['answer'] = result.res_data[0].answers[i].answers
							json['points'] = result.res_data[0].answers[i].points
							json['type'] = result.res_data[0].type
							
							_that.ques_ans_array[result.res_data[0].answers[i].ques_id] = json
							_that.answer_Selected[result.res_data[0].answers[i].ques_id] = json.ans_id

							// const knowledgedata = result.res_data[0]
							// for(const key in knowledgedata){
							// 	let data = knowledgedata[key]
							// 	credentials.localParams.parameter.knowledgeArrayList[data.type] = data
							// }
							// console.log(result.res_data[0].answers.length, "knowledgeArrayList===<")
						}

						

						// const arrayOfKeyValuePairs = Object.filter(result.res_data[0], item => item.type == 'Knowledge');

						// const filteredArray = arrayOfKeyValuePairs.filter(([key, item]) => {
						// 	return item.type === 'Trading Experience'; // Filter even values
						//   });

						// const trading_ques_ans = Object.filter(result.res_data[0], item => item.type === 'Trading Experience');
						// const knowledge_ques_ans = Object.filter(result.res_data[0], item => item.type === 'Knowledge');

						// console.log('Tag', filteredArray);
						// console.log('asfse', arrayOfKeyValuePairs);

						if (result.res_data[0].step >= 3) {
							credentials.localParams.parameter.disable = true;
						} else {
							// console.log(result.res_data[0].step)
							if (result.res_data[0].step > 2) {
								// console.log("result.res_data[0].step=======>", result.res_data[0].step)
								if (parseInt(result.res_data[0].profile.total_points) < 3) {
									credentials.localParams.parameter.test_failed = 1
								}
								else if (parseInt(result.res_data[0].profile.total_points) > 2 && parseInt(result.res_data[0].profile.total_points) < 16) {
									credentials.localParams.parameter.test_failed = 3
									credentials.localParams.parameter.show_warning = true
								}
								else {
									//do nothing over her
								}
							}
						}
						break;
					case 4:
						if (parseInt(result.res_data[0].profile.terms_agreed) == 1) {
							_that.showRisk = false; // hide warning popup in case of pass and checked
							_that.check1 = true
							_that.check2 = true
							_that.check3 = true
							_that.check4 = true
						}else if(parseInt(result.res_data[0].profile.total_points) > 15){
							// test pass but show msg popup
							_that.showRisk = true;
						}else if(parseInt(result.res_data[0].profile.total_points) <= 15){
							// test failed show warning popup
							switch (parseInt(result.res_data[0].profile.risk_warning)){
								case 0:
									// poup warning not accepted neither rejected
									_that.showRisk = true;
									break;
								case 1:
									// poup warning accepted, so don't show warning
									_that.showRisk = false;
									break;
								case 2:
									// poup warning rejected, so show test failed message
									_that.testFail = true;
									break;
								default:
									break;
							}
						}
						break;
					case 5:
						if (parseInt(result.res_data[0].profile.APPROVED_TO_PROCEED) == 1) {
							_that.acceptCountryFlag = 1
						} else {
							_that.acceptCountryFlag = 2
						}
					case (5.1):
						if(credentials.localParams.step == 5.1){
							if (result.res_data[0].documents.length > 0) {
								for (let i = 0; i <= result.res_data[0].documents.length - 1; i++) {
									let data = result.res_data[0].documents[i]
									if(data.document_type){
										if (_that.documentJsonData[data.document_type.split(' ').join('_')] == undefined) {
											_that.documentJsonData[data.document_type.split(' ').join('_')] = []
										}
										data.name = data.document
										_that.documentJsonData[data.document_type.split(' ').join('_')].push(data)
									}
								}
								// console.log(_that.documentJsonData)
							} else {
								// _that.documentJsonSitutaion = { 'identity_document': 'upload', 'residence_document': 'upload', 'ipv_document': 'upload' }
							}


							_that.idnumber = result.res_data[0].profile.P_IDNUMBER

							if (parseInt(result.res_data[0].profile.APPROVED_TO_PROCEED) == 1) {
								_that.acceptCountryFlag = 1
							} else {
								_that.acceptCountryFlag = 2
							}
						}
						break;
				}
			}
		})
	},
	[Const.RUN_USER_NOTIFICATIONS]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_USER_NOTIFICATIONS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_USER_NOTIFICATIONS, result.res_data)
			} else {
				commit(Const.SET_USER_NOTIFICATIONS, [])
			}
		})
	},
	[Const.RUN_GET_COUNTRIES_LIST]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_COUNTRIES_LIST, credentials, credentials.localParams.parameter, '', commit, (error, result) => {
			if (!error) {
				let country_array = [], count = 0;
				for (var key in result.res_data) {
					count++
					country_array.push(result.res_data[key])
					if (count == Object.keys(result.res_data).length) {
						commit(Const.SET_COUNTRIES_LIST, country_array)
						if (credentials.localParams.page) {
							credentials.localParams.parameter.residence_country = credentials.localParams.parameter.RemoveNode('US')
						}
					}
				}
			} else {
				commit(Const.SET_COUNTRIES_LIST, [])
			}
		})
	},
	[Const.RUN_GET_CITIES_LIST]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_CITIES_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_CITIES_LIST, result.res_data)
			} else {
				commit(Const.SET_CITIES_LIST, [])
			}
		})
	},
	//=================================trading accounts====================================================
	[Const.RUN_CREATE_API_SUBSCRIPTION]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_CREATE_API_SUBSCRIPTION, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				dispatch(Const.RUN_GET_TRADING_ACCOUNT_LIST, { 'globalParams': {}, 'localParams': { 'parameter': credentials.localParams.parameter, 'page': 'rest-api' } });
				credentials.localParams.parameter.congratulation_module = true
				credentials.localParams.parameter.account_detail = result.res_data.account
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_CREATE_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {


		_executeApi(Enpoints.EP_CREATE_ACCOUNT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				dispatch(Const.RUN_GET_TRADING_ACCOUNT_LIST, { 'globalParams': {}, 'localParams': { 'parameter': credentials.localParams.parameter } });
				credentials.localParams.parameter.congratulation_module = true
				credentials.localParams.parameter.account_detail = result.res_data.account
				if(credentials.globalParams.demo_live && parseInt(credentials.globalParams.demo_live) == 1){
					/*window.twq('event', 'tw-och2p-octc7', {});*/
					try {
						let user_json = getters['GET_USER']
						const user_id = user_json.profile.user_id

						window.gtag('event', 'Verified_live_Account', {'event_name': 'Verified_Live_Ac', 'user_id': "EU_"+user_id/*, 'send_to': 'G-1E20EEPN1W'*/ });
						window.fbq('trackCustom', 'Verified_live_Account', { 'value': '50', 'country':  user_json.profile.residence_country, 'Currency': 'USD'}, { 'eventID': result.res_data.account.account_id });
					} catch (ex) {
						console.log('ex', ex)
					}
				}else if(parseInt(credentials.globalParams.demo_live) == 1){
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				/*try {
					window.dataLayer.push({ 'event' : 'error', 'errorType': 'create tading account error', 'errorMessage': result.res_data });
				} catch (ex) {
					console.log('ex', ex)
				}*/
			}
		})
	},
	[Const.RUN_GET_ACCOUNT_HISTORY]({ commit, state, getters, dispatch }, credentials) {
		_executeApi('/get/account/history', credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let account_detail = getters[Const.GET_ACCOUNT_DETAILS]
				account_detail.history.csv_array = result.res_data
				commit(Const.SET_ACCOUNT_DETAILS, account_detail)
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_ADD_LAST_SELECT_TRADING_ACCOUNT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_RUN_ADD_LAST_SELECT_TRADING_ACCOUNT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, credentials.localParams.getData)
				//localStorage.setItem('last_select_trading_account', JSON.stringify(credentials.localParams.getData))
				credentials.localParams.parameter.$parent.showTradingAccountModal = false
				let json_data = {
					'globalParams': {
						'act_account_id': credentials.localParams.getData[0].act_account_id,
						'account_id': credentials.localParams.getData[0].account_id,   //5111714, 
						'demo_live': credentials.localParams.getData[0].demo_live,
						'platform': credentials.localParams.getData[0].platform
					}, 'localParams': { 'parameter': credentials.localParams.parameter }
				}
				/*if(credentials.localParams.getData[0].platform == 'ACT'){
					json_data.globalParams.account_id = credentials.localParams.getData[0].act_account_id
				}*/
				dispatch(Const.RUN_GET_TRADING_ACCOUNT_DETAILS, json_data);
			} else {
				commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, [])
			}
		})
	},
	[Const.RUN_GET_TRADING_ACCOUNT_DETAILS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TRADING_ACCOUNT_DETAILS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {       //single api from frontend which fetch  balance margin and trade of last selected trading account
				if (credentials.localParams.module == 'withdrawal') {
					credentials.localParams.parameter.balance = result.res_data.margin_detail.equity
					credentials.localParams.parameter.free_margin = result.res_data.margin_detail.freeMargin
				} else if (credentials.localParams.module == 'remove-bonus') {
					credentials.localParams.parameter.bonus = result.res_data.margin_detail.credit
				} else if (credentials.localParams.module == 'from') {
					credentials.localParams.parameter.fromBalance = result.res_data.margin_detail.freeMargin
					credentials.localParams.parameter.fromBalanceCurr = result.res_data.margin_detail.freeMargin + credentials.localParams.parameter.from_currency
				} else if (credentials.localParams.module == 'to') {
					credentials.localParams.parameter.toBalance = result.res_data.margin_detail.freeMargin
					credentials.localParams.parameter.toBalanceCurr = result.res_data.margin_detail.freeMargin + credentials.localParams.parameter.to_currency
				} else {
					if (credentials.globalParams.platform != 'ACT') {

						if (result.res_data.open_trades.csv_array && (result.res_data.open_trades.csv_array).length > 1) {
							result.res_data.open_trades.csv_array.shift()
						} else {
							result.res_data.open_trades.csv_array = []
						}


						if (result.res_data.history.csv_array && (result.res_data.history.csv_array).length > 1) {
							result.res_data.history.csv_array.shift()
						} else {
							result.res_data.history.csv_array = []
						}
					} else if (credentials.localParams.module == 'from') {
						credentials.localParams.parameter.fromBalance = ''
						credentials.localParams.parameter.fromBalanceCurr = ''
					} else if (credentials.localParams.module == 'to') {
						credentials.localParams.parameter.toBalance = ''
						credentials.localParams.parameter.toBalanceCurr = ''
					}
					commit(Const.SET_ACCOUNT_DETAILS, result.res_data)



					/*if(credentials.globalParams.platform != 'ACT' && result.res_data.open_orders.csv_array){
						result.res_data.open_orders.csv_array.shift()
						result.res_data.open_trades.csv_array.shift()
						result.res_data.history.csv_array.shift()
					}else if(credentials.globalParams.platform != 'ACT' && !result.res_data.open_orders.csv_array){
						result.res_data.open_orders = {}
						result.res_data.open_trades = {}
						result.res_data.history = {}
					}else if(credentials.localParams.module == 'from'){
						credentials.localParams.parameter.fromBalance = ''
						credentials.localParams.parameter.fromBalanceCurr = ''
					}else if(credentials.localParams.module == 'to'){
						credentials.localParams.parameter.toBalance = ''
						credentials.localParams.parameter.toBalanceCurr = ''
					}
					commit(Const.SET_ACCOUNT_DETAILS, result.res_data)*/
				}
			} else {
				commit(Const.SET_ACCOUNT_DETAILS, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_ACCOUNT_PRIORITY_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_ACCOUNT_PRIORITY_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_ACCOUNT_DETAILS, [])
				credentials.localParams.parameter.id = ''
				credentials.localParams.parameter.tradingAccountListFunc()
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_TRADING_ACCOUNT_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TRADING_ACCOUNT_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.page && credentials.localParams.page == 'rest-api') {
					if (result.res_data.totalRecords > 0) {
						let count1 = 0;
						for (let i = 0; i <= result.res_data.totalRecords - 1; i++) {

							if (parseInt(result.res_data.records[i].demo_live) == 1 && parseInt(result.res_data.records[i].is_api_account) == 1) {
								count1++
							}
							if (result.res_data.records.length - 1 == i) {
								credentials.localParams.parameter.totalRestApiAccounts = count1
								credentials.localParams.parameter.restApiAccountsData = result.res_data
							}
						}
					} else {
						credentials.localParams.parameter.totalRestApiAccounts = 0
						credentials.localParams.parameter.restApiAccountsData = []
					}
				} else {
					if (result.res_data.totalRecords > 0) {
						let live = 0, liveArray = [], demo = 0, demoArray = [];
						for (let i = 0; i <= result.res_data.totalRecords - 1; i++) {

							if (parseInt(result.res_data.records[i].demo_live) == 1) {
								live++
								liveArray.push(result.res_data.records[i])
							}
							if (parseInt(result.res_data.records[i].demo_live) == 0) {
								demo++
								demoArray.push(result.res_data.records[i])
							}

							if (parseInt(result.res_data.records[i].last_selected) == 1) {
								commit(Const.SET_LAST_SELECT_TRADING_ACCOUNT, [result.res_data.records[i]])
							}
							if (result.res_data.records.length - 1 == i) {


								let demoArray1 = demoArray.sort(compare);
								let liveArray1 = liveArray.sort(compare);

								result.res_data.totalLiveAccounts = live
								result.res_data.records = liveArray1.concat(demoArray1)

								commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data)
								commit(Const.SET_DEMO_ACCOUNT_LIST, { 'records': demoArray1, 'totalRecords': demo })
								commit(Const.SET_LIVE_ACCOUNT_LIST, { 'records': liveArray1, 'totalRecords': live })

								if (credentials.localParams.demo_live) {
									credentials.localParams.parameter.accountSelectFunc()
								}


								/*result.res_data.totalLiveAccounts = live
								commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data)
								
								
								let demoArray1 =  demoArray.sort(compare);
								commit(Const.SET_DEMO_ACCOUNT_LIST, {'records' : demoArray1 , 'totalRecords' : demo })
								
								
								

								let liveArray1 =  liveArray.sort(compare);
								commit(Const.SET_LIVE_ACCOUNT_LIST, {'records' : liveArray1 , 'totalRecords' : live })
								
								if(credentials.localParams.demo_live){
									credentials.localParams.parameter.accountSelectFunc()
								}*/
							}
						}
					} else {
						result.res_data.totalLiveAccounts = 0
						commit(Const.SET_LIVE_ACCOUNT_LIST, { 'records': [], 'totalRecords': 0 })
						commit(Const.SET_DEMO_ACCOUNT_LIST, { 'records': [], 'totalRecords': 0 })
						commit(Const.SET_TRADING_ACCOUNT_LIST, result.res_data)
						if (credentials.localParams.demo_live) {
							credentials.localParams.parameter.accountSelectFunc()
						}
					}
				}
			} else {
				if (credentials.localParams.page && credentials.localParams.page == 'rest-api') {
					credentials.localParams.parameter.totalRestApiAccounts = 0
					credentials.localParams.parameter.restApiAccountsData = []
				} else {
					commit(Const.SET_LIVE_ACCOUNT_LIST, [])
					commit(Const.SET_DEMO_ACCOUNT_LIST, [])
					commit(Const.SET_TRADING_ACCOUNT_LIST, [])
				}
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//=================================manage-account======================================================
	[Const.RUN_AMOUNT_CONVERSION_API]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_AMOUNT_CONVERSION_API, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.conversionAmount = true
				credentials.localParams.parameter.responseAmount = result.res_data
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_ACCOUNT_PASSWORD_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_ACCOUNT_PASSWORD_REQUEST_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				credentials.localParams.parameter.transaction_id = result.res_data.trans_id
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_ACCOUNT_PASSWORD_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_ACCOUNT_PASSWORD_CHECK_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.transaction_id = ''
					credentials.localParams.parameter.congModulePass = true
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}

			}
		})
	},
	[Const.RUN_INTERNAL_TRANSFER_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_INTERNAL_TRANSFER_CHECK_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.transaction_id = ''
					credentials.localParams.parameter.congModuleIntTransfer = true
					let json = {
						'account_id': result.res_data.account_id,
						'to_account_id': result.res_data.to_account_id,
						'amount': result.res_data.amount,
						'trans_amount': result.res_data.to_amount
					}
					credentials.localParams.parameter.res_data = json
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}
			}
		})
	},
	[Const.RUN_ACCOUNT_LEVERAGE_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_ACCOUNT_LEVERAGE_CHECK_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.transaction_id = ''
					credentials.localParams.parameter.congModuleLev = true
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}
			}
		})
	},
	[Const.RUN_RESEND_EMAIL_LINK_ACCOUNTS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_RESEND_EMAIL_LINK_ACCOUNTS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz16', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//=================================bonus===============================================================
	[Const.RUN_TRADING_BONUS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_TRADING_BONUS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.bonus = result.res_data.allowedBonus
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_BONUS_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_BONUS_REQUEST_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				credentials.localParams.parameter.transaction_id = result.res_data.trans_id
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_BONUS_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_BONUS_CHECK_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let _that = credentials.localParams.parameter
				if (credentials.localParams.params) {
					_that.success = true
				} else {
					_that.transaction_id = ''
					_that.congModuleBonus = true
					_that.balance_bonus = parseFloat(_that.bonus) - parseFloat(_that.amount)
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}
			}
		})
	},
	[Const.RUN_GET_BONUS_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_BONUS_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_BONUS_LIST, result.res_data)
			} else {
				commit(Const.SET_BONUS_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_REMOVE_BONUS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_REMOVE_BONUS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.congModuleBonus = true
					credentials.localParams.parameter.transaction_id = ''
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}
			}
		})
	},
	[Const.RUN_RESEND_EMAIL_LINK_BONUS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_RESEND_EMAIL_LINK_BONUS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz16', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//=================================withdrawal==========================================================
	[Const.RUN_GET_WITHDRAWAL_DESC]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_DESC, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.free_margin = result.res_data.margin_detail.freeMargin
				let currencyIcon = { 'EUR': '€', 'USD': '$', 'GBP': '£', 'CHF': 'CHF', 'JPY': '¥', 'AUD': '$' }
				credentials.localParams.parameter.free_margin_currency = result.res_data.margin_detail.freeMargin + ' ' + currencyIcon[credentials.localParams.parameter.currencyData]
				if (Object.keys(result.res_data.allowedWithdrawal).length > 0) {
					credentials.localParams.parameter.allowedWithdrawal = result.res_data.allowedWithdrawal
				} else {
					let json = {}, count = 0
					let get_withdrawal_method = getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP]
					for (var key in get_withdrawal_method) {
						count++

						json[key] = {}
						let count1 = 0
						for (var innerkey in get_withdrawal_method[key]) {
							count1++
							json[key][innerkey] = {}
							json[key][innerkey][credentials.localParams.parameter.currencyData] = result.res_data.margin_detail.freeMargin
							if (parseInt(key) != 5) {
								json[key][innerkey]['allowed'] = '1'
							}
						}
						if (count == Object.keys(get_withdrawal_method).length) {
							console.log("=======I m IN IF Callback====>")
							credentials.localParams.parameter.allowedWithdrawal = json
							credentials.localParams.parameter.showBalPanel = false
						}
					}
				}

				credentials.localParams.parameter.pay_option = ''
				credentials.localParams.parameter.amount = ''
				credentials.localParams.parameter.avalBalance = ''
				credentials.localParams.parameter.account_number = ''
				credentials.localParams.parameter.submitted = false
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_WITHDRAWAL_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_WITHDRAWAL_REQUEST_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let user_json = getters['GET_USER']
				credentials.localParams.parameter.transaction_id = result.res_data.trans_id
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_WITHDRAWAL_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_WITHDRAWAL_CHECK_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = true
				} else {
					credentials.localParams.parameter.transaction_id = ''
					credentials.localParams.parameter.congModuleWithdrawal = true
				}
			} else {
				if (credentials.localParams.params) {
					credentials.localParams.parameter.success = false
					credentials.localParams.parameter.msg = result.res_data
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}
			}
		})
	},
	[Const.RUN_GET_WITHDRAWAL_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_WITHDRAWAL_LIST, result.res_data)
			} else {
				commit(Const.SET_WITHDRAWAL_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_RESEND_EMAIL_LINK]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_RESEND_EMAIL_LINK, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz16', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_WITHDRAWAL_METHODS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_WITHDRAWAL_METHODS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			
			if (!error) {
				//withdrawalMethodResponse
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, result.res_data)
				let json = {}, count = 0;
				for (var key in result.res_data) {
					count++
					json[key] = {}
					let count1 = 0
					for (var innerkey in result.res_data[key]) {
						count1++
						json[key][result.res_data[key][innerkey].id] = result.res_data[key][innerkey]
						if (count1 == Object.keys(result.res_data[key]).length) {
							//console.log(json)
						}
					}
					if (count == Object.keys(result.res_data).length) {
						commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, json)
					}
				}
			} else {
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP, [])
				commit(Const.SET_WITHDRAWAL_METHOD_RESPONSE, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},

	//=================================deposit=============================================================  	
	[Const.RUN_TRANS_LIMIT_CURRENCY]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_TRANS_LIMIT_CURRENCY, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.shwStep = 2
				credentials.localParams.parameter.responseTransLimitData = result.res_data
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_TRANSACTION_STATUS]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TRANSACTION_STATUS, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (result.res_data.length > 0) {
					credentials.localParams.parameter.trans_hitory = result.res_data
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_DEPOSIT_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_DEPOSIT_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_DEPOSIT_LIST, result.res_data)
				// if(credentials.localParams.from && credentials.localParams.from == 'header'){
				try{
					credentials.localParams.parameter.callDepositFunc()
				}catch(e){}
				// }
			} else {
				commit(Const.SET_DEPOSIT_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_CREDIT_CARD_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_CREDIT_CARD_DEPOSIT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (result.res_data.url) {
					window.open(result.res_data.url, '_blank');
				} else {
					credentials.localParams.parameter.transaction_id = result.res_data.transaction_id
					credentials.localParams.parameter.submitPay(result.res_data.transaction_id);
				}
				/*try {
					window.dataLayer.push({ 'event' : 'addfund', 'fundMethod' : 'card', })
				} catch (ex) {
					console.log('ex', ex)
				}*/
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_DEMO_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_DEMO_DEPOSIT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.reset()
				if (credentials.localParams.page == 'man_account') {
					credentials.localParams.parameter.fund_msz = 'fund_msz'
					credentials.localParams.parameter.fund_msz_type = 'success'
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz17', 'success')
				}


			} else {
				if (credentials.localParams.page == 'man_account') {
					credentials.localParams.parameter.fund_msz = result.res_data
					credentials.localParams.parameter.fund_msz_type = 'error'
				} else {
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
				}

			}
		})
	},
	[Const.RUN_GET_USER_CAN_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_USER_CAN_DEPOSIT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_DEPOSIT_LIMIT, result.res_data)
			} else {
				commit(Const.SET_DEPOSIT_LIMIT, [])
				//_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},


	//=================================support==============================================================
	[Const.RUN_TICKET_RESEND_OTP]({ commit, state, getters, dispatch }, credentials) {
		credentials.localParams.parameter.submitted = false
		_executeApi(Enpoints.EP_TICKET_RESEND_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter.$parent, 'suceessMsz18', 'success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter.$parent, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_TICKET_REQUEST_OTP]({ commit, state, getters, dispatch }, credentials) {
		credentials.localParams.parameter.submitted = false
		_executeApi(Enpoints.EP_TICKET_REQUEST_OTP, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.trans_id = result.res_data.trans_id
				if (credentials.localParams.type && credentials.localParams.type == 'pro') {
					credentials.localParams.parameter.show_step = ''
				}
			} else {
				if (credentials.localParams.type && credentials.localParams.type == 'pro') {
					credentials.localParams.parameter.show_step = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_TICKET_CHECK_OTP]({ commit, state, getters, dispatch }, credentials) {
		let localParam = credentials.localParams
		localParam.parameter.submitted = false
		localParam.parameter.$parent.submitted = false
		_executeApi(Enpoints.EP_TICKET_CHECK_OTP, credentials, credentials.localParams.parameter.$parent, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (parseInt(localParam.module) == 1 && parseInt(localParam.title) == 87) {
					credentials.localParams.parameter.$parent.$parent.$parent.$parent.logout()
					//_messageDisplayFunction(credentials.localParams,'as you have changed your primary email , so please login again','success')
				} else if (parseInt(localParam.module) == 1 && parseInt(localParam.title) == 88) {
					let get_user = getters[types.GET_USER]
					get_user.mobile_no = localParam.data
					commit(types.SET_STATE, get_user)

					var user = localStorage.getItem('user')
					user = atob(user) 
					user = JSON.parse(user)
					user.mobile_no = credentials.localParams.data
					localStorage.setItem('user', btoa(JSON.stringify(user)))
					localParam.parameter.$parent.congModule = true
				} else if (credentials.localParams.data && credentials.localParams.data == 'pro') {
					credentials.localParams.parameter.$parent.show_step = ''
					localParam.parameter.$parent.congModule = true
				} else if (parseInt(localParam.module) == 16) {  //pehle 93 tha 
					if (localParam.ticketRequestFrom == 'deposit') {
						localParam.parameter.$router.replace({ name: "fxView.deposit", params: { account_id_from_ticket: localParam.accountId } })
					} else if (localParam.ticketRequestFrom == 'profile') {
						localParam.parameter.$router.replace('/profile')
						_messageDisplayFunction(credentials.localParams.parameter.$parent, 'bank add successfully', 'success')
						/*try {
							window.dataLayer.push({ 'event' : 'addpaymentinfo', 'paymentMethod' : 'bank', })
						} catch (ex) {
							console.log('ex', ex)
						}*/
					} else if (localParam.ticketRequestFrom == 'profileOtp') {
						credentials.localParams.parameter.$parent.trans_id = ''
						credentials.localParams.parameter.$parent.getUserProfileFunc()
						_messageDisplayFunction(credentials.localParams.parameter.$parent, 'payment method disable successfully', 'success')
					} else {
						localParam.parameter.$parent.congModule = true
					}
				} else {
					localParam.parameter.$parent.congModule = true
				}

			} else {
				if (credentials.localParams.data && credentials.localParams.data == 'pro') {
					credentials.localParams.parameter.$parent.show_step = ''
				}
				_messageDisplayFunction(credentials.localParams.parameter.$parent, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_TICKET_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TICKET_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_TICKET_LIST, result.res_data)
			} else {
				commit(Const.SET_TICKET_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_TICKET_REASON_LIST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TICKET_REASON_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let ticketData = _ticketFunction(result.res_data)
				// console.log(ticketData, "ticketData >>>>>>>>>>>>.")
				commit(Const.SET_TICKET_DATA, ticketData)
				let count = 0
				for (var key in result.res_data) {
					count++
					if (result.res_data[key].categories && result.res_data[key].categories != undefined && result.res_data[key].categories.length > 0) {
						let categoriesList = {}
						for (let i = 0; i <= result.res_data[key].categories.length - 1; i++) {

							categoriesList[result.res_data[key].categories[i].id] = result.res_data[key].categories[i]
							if (i == result.res_data[key].categories.length - 1) {
								delete result.res_data[key].categories
								result.res_data[key]['categories'] = categoriesList
							}
						}
					}
					if (count == Object.keys(result.res_data).length) {
						commit(Const.SET_TICKET_REASON_LIST, result.res_data)
					}
				}

			} else {
				commit(Const.SET_TICKET_REASON_LIST, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_TICKET_DETAIL]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_TICKET_DETAIL, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_TICKET_VIEW, result.res_data)
			} else {
				commit(Const.SET_TICKET_VIEW, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_TICKET_REPLY]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_TICKET_REPLY, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.ticketDetail()
				credentials.localParams.parameter.clear()
				let user_notify = getters[Const.GET_USER_NOTIFICATIONS]
				let i;
				if (user_notify.length > 0) {
					for (i = 0; i <= user_notify.length - 1; i++) {
						if (user_notify[i].notification_type == 'TICKET' && user_notify[i].ticket_id == credentials.localParams.tick_id) {
							let user_info = getters[types.GET_USER]
							user_info.unread_notification = user_info.unread_notification - 1
							commit(types.SET_STATE, user_info)

							var user = localStorage.getItem('user')
							user = atob(user); 
							user = JSON.parse(user)
							user.unread_notification = user.unread_notification - 1
							localStorage.setItem('user', btoa(JSON.stringify(user)))
						}
					}
				}
				//_messageDisplayFunction(credentials.localParams.parameter,'message sent successfully','success')
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//=================================bank=================================================================
	[Const.RUN_ADD_BANK]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_ADD_BANK, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				_messageDisplayFunction(credentials.localParams.parameter, 'suceessMsz19', 'success')
				/*try {
					window.dataLayer.push({ 'event' : 'addpaymentinfo', 'paymentMethod' : 'bank', })
				} catch (ex) {
					console.log('ex', ex)
				}*/
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_BANK_LIST]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_BANK_LIST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_BANK_LIST, result.res_data)
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_SUBMIT_CONSENT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_SUBMIT_CONSENT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.refetchUserData()
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},//=================================dashboard chart======================================================
	[Const.RUN_GET_PROFIT_CHART_DATA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_PROFIT_CHART_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter
				_that.profitData = result.res_data
				_that.create_chart()
			}
		})
	},
	[Const.RUN_GET_BALANCE_DATA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_BALANCE_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter
				_that.profitData = result.res_data
			}
		})
	},
	[Const.RUN_GET_EQUITY_DATA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_EQUITY_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter
				_that.profitData = result.res_data
			}
		})
	},
	[Const.RUN_GET_TRADING_DATA]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_TRADING_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter
				_that.tradingData = result.res_data
				_that.create_pie_chart()
			}
		})
	},
	[Const.RUN_GET_IDENFY_TOKEN]({ commit, state, dispatch, getters }, credentials) {
		_executeApi(Enpoints.EP_GET_IDENFY_TOKEN, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				const _that = credentials.localParams.parameter

				if (_that.$route.path == '/index') {
					_that.intializeSumSub(result.res_data.accesstoken, result.res_data.user_id, result.res_data.levelname)
				} else {
					let payLoad = { "accessToken": result.res_data.accesstoken, "user_id": result.res_data.user_id, "levelname": result.res_data.levelname }

					EventBus.$emit('INTIALIZESUMSUB', payLoad);
				}



				// _that.iframe.src = "https://ui.idenfy.com/?authToken="+result.res_data.authToken
			}
		})
	},
	[Const.RUN_GET_TUT_COURSE_CATEGORY]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_TUT_COURSE_CATEGORY, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				credentials.localParams.parameter.course_cat = result.res_data
				if (Object.keys(result.res_data).length > 0 && result.res_data.course.length > 0 && Object.keys(result.res_data.category).length > 0) {
					credentials.localParams.parameter.courseId = result.res_data.course[0]._id
					if (result.res_data.category[result.res_data.course[0]._id].length > 0) {
						credentials.localParams.parameter.categoryId = result.res_data.category[result.res_data.course[0]._id][0]._id
						let input_json = {
							'globalParams': {
								"course_id": result.res_data.course[0]._id, "cat_id": result.res_data.category[result.res_data.course[0]._id][0]._id
							},
							'localParams': { "parameter": credentials.localParams.parameter }
						}
						dispatch(Const.RUN_GET_VIDEO_TUTORIAL, input_json);
					}
				} else {
					credentials.localParams.parameter.course_cat = {}
				}
			} else {
				credentials.localParams.parameter.course_cat = {}
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_VIDEO_TUTORIAL]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_GET_VIDEO_TUTORIAL, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				commit(Const.SET_VIDEO_TUTORIAL, result.res_data)
			} else {
				commit(Const.SET_VIDEO_TUTORIAL, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_GET_HOOPS_DATA]({ commit, state, getters, dispatch }, credentials) {
		let hoops_data = [];
		let hoops_dataJson = getters[Const.GET_HOOPS_DATA]
		_executeApi(Enpoints.EP_GET_HOOPS_DATA, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				if (parseInt(credentials.localParams.parameter.page) > 1) {
					if (hoops_dataJson.totalRecords) {
						hoops_dataJson['totalRecords'] = result.res_data.length + hoops_dataJson['totalRecords']
						hoops_dataJson['records'] = hoops_dataJson['records'].concat(result.res_data)
					} else {
						hoops_dataJson['totalRecords'] = result.res_data.length
						hoops_dataJson['records'] = result.res_data
					}
					commit(Const.SET_HOOPS_DATA, hoops_dataJson)
				} else {
					let hoops_data = {}
					hoops_data['totalRecords'] = result.res_data.length
					hoops_data['records'] = result.res_data
					commit(Const.SET_HOOPS_DATA, hoops_data)
				}
			} else {
				commit(Const.SET_HOOPS_DATA, [])
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	[Const.RUN_UPDATE_FIRST_DEPOSIT]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_UPDATE_FIRST_DEPOSIT, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				let get_user = getters[types.GET_USER]
				if(Object.keys(get_user).length > 0){
					get_user.first_deposit = 1
					commit(types.SET_STATE, get_user)
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
	//============================ NUVEI REQUEST ==================================================
	// [Const.RUN_NUVEI_REQUEST]({ commit, state, getters, dispatch }, credentials) {
    //     COMMON._executeApi(Enpoints.EP_NUVEI_REQUEST, credentials, { Authorization: "Bearer " + getters.GET_TOKEN }, commit, (error, result) => {
    //         if (!error) {
    //             goToUrl(result.res_data.paymentUrl, "_blank");
    //         } else {
    //             _messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
    //         }
    //     });
    // },
	[Const.RUN_NUVEI_REQUEST]({ commit, state, getters, dispatch }, credentials) {
		_executeApi(Enpoints.EP_NUVEI_REQUEST, credentials, credentials.localParams.parameter, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
			if (!error) {
				console.log(result.res_data, ">>>>>>>>>>>>>>>>>>>>>>>>result.res_data.paymentUrl")
				if (result.res_data.paymentUrl) {
					window.open(result.res_data.paymentUrl, '_blank');
				} else {
					// credentials.localParams.parameter.transaction_id = result.res_data.transaction_id
					// credentials.localParams.parameter.submitPay(result.res_data.transaction_id);
					_messageDisplayFunction(credentials.localParams.parameter, result.res_data, "error");
				}
			} else {
				_messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
			}
		})
	},
}
//=================================Functions============================================================
function _cleanUp(commit, msg, status, loaderId) {
	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
	commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
	let response = { info: 'NOK', msg: 'Service not available' }
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
				response = { info: 'NOK', msg: 'Network Error' }
			}
		} catch (e) { }
	} else {
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if (typeof e.response !== 'undefined') {
		if (e.response.status == 401) {
			localStorage.setItem('unauthFlag', true)
			localStorage.setItem('loggedIn', false)

			let data = {}
			let options = {}
			options.forward = true
			window.dispatchEvent(new Event('storage'));
			//_handleLogout(data, commit, options)
		}
	}
}
function _handleLogout(data, commit, options) {
	let user = {}
	const state = []
	localStorage.removeItem('user');
	localStorage.setItem('unauthFlag', false)
	sessionStorage.clear();
	if ('msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		window.location.href = "/";
	}
}
function compare(a, b) {
	if (a.priority < b.priority)
		return -1;
	if (a.priority > b.priority)
		return 1;
	return 0;
}
function _ticketFunction(respData) {
	// priority basis keys 
	//parent  ['1', '3', '4', '2']
	const getResponseData = respData
	let keyByPriortity = []
	let obj = {}
	let count = 0
	for (var key in getResponseData) {
		const parent_id = getResponseData[key].id
		keyByPriortity[getResponseData[key].priority] = parent_id
		obj["-1"] = keyByPriortity

		let childCount = 0
		count++
		const child = getResponseData[key].categories
		//console.log(child)
		if (child) {
			let childPriority = []
			for (var i = 0; i <= child.length - 1; i++) {
				const children = child[i]
				childPriority[children.priority] = children.id
				childCount++
				if (i == child.length - 1) {
					//empty
					var filtered = childPriority.filter(function (el) {
						return el != null && el != '';
					});
					obj[parent_id] = filtered
				}
				if (i == child.length - 1 && count == Object.keys(getResponseData).length) {
					var childfiltered = keyByPriortity.filter(function (el) {
						return el != null && el != '';
					});
					obj["-1"] = childfiltered
					return obj
				}
			}
		} else {
			if (count == Object.keys(getResponseData).length) {
				var childfiltered = keyByPriortity.filter(function (el) {
					return el != null && el != '';
				});
				obj["-1"] = childfiltered
				return obj;
			}
		}

	}


	//return keyByPriortity
}
function _executeApi(apiLink, credentials, getLoaderParams, getToken, commit, callback) {
	try {

		let response_array = []
		if (credentials.localParams.module == 'ticket-reply') { credentials.globalParams = credentials.globalParams.form }
		if (getToken == '') { getToken = '' }
		if (credentials.localParams.loaderFuncRun && credentials.localParams.loaderFuncRun == '0') {
			getLoaderParams.pageLoader = false
		} else if (credentials.localParams.tick_id) {
			getLoaderParams.pageLoader = false
			getLoaderParams.type_ticket_detail = true
		} else if (credentials.localParams.page == 'man_account') {
			getLoaderParams.pageLojader = false
			getLoaderParams.depositAddLoader = true
		} else {
			getLoaderParams.pageLoader = true
		}
		if (credentials.localParams.isLoadingCount > 0) {
			loaderRun = loaderRun + 1;
		}

		RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
			.map(response => response.data)
			.subscribe(data => {
				if (credentials.localParams.tick_id) {
					getLoaderParams.type_ticket_detail = false
				} else if (credentials.localParams.page == 'man_account') {
					getLoaderParams.depositAddLoader = false
				}
				
				if (credentials.localParams.isLoadingCount === loaderRun) {
					loaderRun = loaderRun - 1;
					getLoaderParams.isLoadingCount = getLoaderParams.isLoadingCount - 1;
				}
				if (!loaderRun) {
					getLoaderParams.pageLoader = false
				}
				
				if ('info' in data) {
					if (data.info === 'OK') {
						response_array.res_data = data.data
						callback(false, response_array)
					} else {
						if (typeof data.msg == 'object') {
							if (data.msg.code == 'BACk_MSG') {
								response_array.res_data = 'BME' + data.msg.msg
							} else if (data.msg.code == 'FILE_UPLOAD') {
								response_array.res_data = data.msg.msg
							} else {
								response_array.res_data = data.msg.code
							}
						} else {
							response_array.res_data = data.msg
						}
						callback(true, response_array)
					}
				}
			},
				e => { _handleErrorResponse(e, commit) })
	} catch (ex) { _handleErrorResponse(ex, commit) }
}
function _messageDisplayFunction(getParameter, getMessage, msgType) {
	getParameter.response_msg = getMessage
	getParameter.msg_type = msgType
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/actions.js